import React, { Component } from "react";
import { matchPath } from "react-router";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as BenefitsActions } from "store/ducks/benefits";

import { Validate, Access } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/components";
import { useDefaultDateFormat } from "helpers";

class Edit extends Component {
  state = {
    data: {
      title: "",
      description: "",
      alias: "",
      experience_voucher_configuration_id: "",
      experience_commercial_campaigns_id: "",
      discount: "",
      value: 0,
      activation_period: true,
      start_at: null,
      end_at: null,
      activation_limit: 0,
      active: false,
      app_only: false,
      store_channels: Access.lockedChannel()
        ? [Access.lockedChannel(true)]
        : [],
      store_channels_all: false,
      cpf_list: [],
      promoted: false,
      extra_data: {
        store_region: null,
        store_places: [],
        store_places_all: true,
        classification_passions: [],
        classification_passions_all: true,
        store_product_types: [],
        store_product_types_all: true,
        store_sections: [],
        store_sections_all: true,
        store_sub_sections: [],
        store_sub_sections_all: true,
        store_groups: [],
        store_sub_groups: [],
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        send_email: true,
        all_products: false,
      },
    },
    errors: {},
    loading: true,
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Lista de Benefícios", to: "/benefits/list" },
      { name: "Editar", to: "" },
    ],
  };

  componentDidMount() {
    const { getBenefitRequest } = this.props;
    getBenefitRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { benefit } = this.props;

    if (oldProps.benefit.loading && !benefit.loading) {
      const values = {
        ...data,
        ...benefit.data.attributes,
        id: benefit.data.id,
        cpf_list:
          benefit.data.attributes.cpf_list !== null
            ? benefit.data.attributes.cpf_list
            : [],
        promoted: benefit.data.attributes.promoted ?? false,
        description:
          benefit.data.attributes.description !== null
            ? benefit.data.attributes.description
            : "",
        experience_commercial_campaigns_id:
          benefit.data.attributes.experience_commercial_campaign !== null
            ? {
                value:
                  benefit.data.attributes.experience_commercial_campaign.id,
                label:
                  benefit.data.attributes.experience_commercial_campaign.title,
              }
            : null,
        alias:
          benefit.data.attributes.alias !== null
            ? benefit.data.attributes.alias
            : "",
        discount: benefit.data.attributes.discount,
        value: benefit.data.attributes.value,
        store_channels: benefit.data.attributes.channels.map((channel) => ({
          value: channel.id,
          label: channel.name,
        })),
        store_channels_all: !benefit.data.attributes.channels.length,
        start_at:
          benefit.data.attributes.start_at !== null
            ? new Date(benefit.data.attributes.start_at)
            : null,
        end_at:
          benefit.data.attributes.end_at !== null
            ? new Date(benefit.data.attributes.end_at)
            : null,
        experience_voucher_configuration_id: benefit.data.attributes
          .voucher_configuration
          ? {
              value: benefit.data.attributes.voucher_configuration.id,
              label: benefit.data.attributes.voucher_configuration.title,
            }
          : "",
        voucher_category_id: benefit.data.attributes.category
          ? {
              value: benefit.data.attributes.category.id,
              label: benefit.data.attributes.category.title,
            }
          : "",
        extra_data: {
          ...data.extra_data,
          ...benefit.data.attributes.extra_data,
        },
      };

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/benefits/:id/edit",
    });
    return match.params.id;
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      discount: {
        range: [1, 99]
      },

      start_at: {
        required: true,
      },

      end_at: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { updateBenefitRequest } = this.props;
    const { filters } = this.props.location;

    updateBenefitRequest(this.handleGetID(), {
      voucher: {
        title: data.title,
        description: data.description,
        cpf_list: data.cpf_list,
        promoted: data.promoted,
        experience_voucher_configuration_id:
          data.experience_voucher_configuration_id?.value,
        experience_commercial_campaigns_id:
          data.experience_commercial_campaigns_id?.value,
        discount: data.discount,
        value:
          data.value === null || data.value === "" ? 0 : parseInt(data.value),
        activation_period: data.activation_period,
        start_at: useDefaultDateFormat(data.start_at),
        end_at: useDefaultDateFormat(data.end_at),
        activation_limit: data.activation_limit,
        alias: data.alias,
        app_only: data.app_only,
        store_channel_ids: !!data.store_channels_all
          ? []
          : data.store_channels.map((channel) => channel.value),

        extra_data: {
          store_region: data.extra_data.store_region,
          store_places: data.extra_data.store_places,
          store_places_all: data.extra_data.store_places_all,
          classification_passions: data.extra_data.classification_passions,
          classification_passions_all:
            data.extra_data.classification_passions_all,
          store_product_types: data.extra_data.store_product_types,
          store_product_types_all: data.extra_data.store_product_types_all,
          store_sections: data.extra_data.store_sections,
          store_sections_all: data.extra_data.store_sections_all,
          store_sub_sections: data.extra_data.store_sub_sections,
          store_sub_sections_all: data.extra_data.store_sub_sections_all,
          store_groups: data.extra_data.store_groups,
          store_sub_groups: data.extra_data.store_sub_groups,
          remove_mdh: data.extra_data.remove_mdh,
          add_mdh: data.extra_data.add_mdh,
          add_store_products: data.extra_data.add_store_products,
          remove_store_products: data.extra_data.remove_store_products,
          send_email: data.extra_data.send_email,
          all_products: data.extra_data.all_products,
        },
      },
      filters,
    });
  };

  render() {
    const { data, errors, breadcrumbs, loading } = this.state;
    const { update } = this.props;
    const { filters } = this.props.location;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          loading={loading}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
          filters={filters}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  benefit: state.benefits.detail,
  update: state.benefits.update,
});

const mapActions = (dispatch) => bindActionCreators(BenefitsActions, dispatch);

export default connect(mapState, mapActions)(Edit);
